import type { ComponentTemplate } from "schemas/generated/componentTemplates";

import { getCanBeAddedFunction } from "../src/utils";

export const carouselWithProductImages: ComponentTemplate = {
  id: "7f094b9b-77ee-498c-8f28-f3900af074f2",
  storeId: null,

  scope: "left-bar",
  type: "component",
  name: "Product/Product Images",
  leftBarCategory: { main: "product", subCategory: "productData" },
  tags: ["carousel"],
  preview: "product/images.png",
  canBeAddedAsChild: getCanBeAddedFunction(
    "product",
    "Product Image Carousels can only be added inside Product boxes.",
  ),
  template: {
    id: "4022e293-6325-4d40-b192-17cdddb7477a",
    name: "Carousel 1",
    type: "carouselV3",
    props: {
      style: {
        display: "flex",
        maxWidth: "805px",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        maxHeight: "805px",
      },
      _items: {
        type: "inline",
        valueType: "dynamic",
        dynamicPath: "{{attributes._product.images}}",
      },
    },
    children: [
      {
        id: "09f4f7e8-a12a-40bd-88b2-d486e9219fdf",
        name: "Previous Button 1",
        type: "carouselV3Control",
        props: {
          style: {
            cursor: "pointer",
            display: "flex",
            flexGrow: "unset",
            flexWrap: "wrap",
            alignSelf: "stretch",
            flexBasis: "auto",
            alignItems: "center",
            justifyContent: "center",
          },
          direction: "previous",
        },
        children: [
          {
            id: "7b168e00-10ad-4a20-bb0a-f46afdb682ba",
            type: "icon",
            props: {
              style: {
                width: "60px",
                height: "60px",
                __width: "60px",
                __height: "60px",
                flexGrow: "unset",
              },
              iconName: "chevronLeft",
            },
            variantOverrides: {},
          },
        ],
        variants: [
          {
            id: "12f8fb6d-1c74-4445-bdb9-109d57b5f479",
            name: "default",
            query: null,
            componentOverrides: null,
          },
          {
            id: "575d80eb-00de-4ec0-a68e-2dc827a817a7",
            name: "First Item",
            query: {
              type: "expression",
              operator: "or",
              statements: [
                {
                  id: "bf8b0b4c-79fd-4043-a18b-9840a038a6e3",
                  field: "state.group.isFirstItemActive",
                  value: null,
                  operator: null,
                },
              ],
            },
            componentOverrides: null,
          },
        ],
        variantOverrides: {
          "575d80eb-00de-4ec0-a68e-2dc827a817a7": {
            componentOverrides: {
              "7b168e00-10ad-4a20-bb0a-f46afdb682ba": {
                props: {
                  style: {
                    opacity: "20%",
                  },
                },
              },
              "09f4f7e8-a12a-40bd-88b2-d486e9219fdf": {
                props: {
                  style: {
                    cursor: "default",
                  },
                },
              },
            },
          },
        },
      },
      {
        id: "1c4768c1-07a9-4bee-9b24-7024cae6e077",
        name: "Container 9",
        type: "container",
        props: {
          style: {
            display: "flex",
            flexGrow: "1",
            maxWidth: "100%",
            alignSelf: "stretch",
            flexBasis: "auto",
            alignItems: "flex-start",
            flexDirection: "column",
            justifyContent: "flex-start",
          },
        },
        children: [
          {
            id: "a67ce2fc-4a47-48cd-b62d-a69ce4435d6a",
            name: "Carousel Slides",
            type: "carouselV3Slides",
            props: {
              style: {
                width: "auto",
                height: null,
                __width: "1197px",
                flexGrow: 1,
                overflow: "hidden",
                alignSelf: "stretch",
                flexBasis: "auto",
              },
            },
            children: [
              {
                id: "08524b79-1bf9-4693-9c16-cab1aa72e4b2",
                name: "Slide 1",
                type: "container",
                props: {
                  style: {
                    __width: "auto",
                    display: "flex",
                    flexGrow: "1",
                    __flexGap: "12px",
                    flexBasis: "auto",
                    alignItems: "center",
                    paddingTop: "24px",
                    paddingBottom: "24px",
                    justifyContent: "center",
                  },
                },
                children: [
                  {
                    id: "932f539f-575e-490e-9a76-4d7dbaf37efd",
                    name: "Image 1",
                    type: "image",
                    props: {
                      src: "",
                      style: {
                        flexGrow: 1,
                        objectFit: "cover",
                        alignSelf: "stretch",
                        __imageSource: "{{attributes._currentItem}}",
                      },
                    },
                  },
                ],
              },
              {
                id: "09aedd29-2c56-4d2e-94d1-3fc566de5dd2",
                name: "Slide 2",
                type: "container",
                props: {
                  style: {
                    __width: "auto",
                    display: "flex",
                    flexGrow: "1",
                    __flexGap: "12px",
                    flexBasis: "auto",
                    alignItems: "center",
                    paddingTop: "24px",
                    paddingBottom: "24px",
                    justifyContent: "center",
                  },
                },
                children: [
                  {
                    id: "b414df70-2b58-4d80-8bfe-2a506496e19a",
                    name: "Image 2",
                    type: "image",
                    props: {
                      src: "",
                      style: {
                        flexBasis: "auto",
                        objectFit: "cover",
                      },
                    },
                  },
                  {
                    id: "c8d52925-dd8f-4c7a-b3d5-5513408c376f",
                    type: "text",
                    props: {
                      text: "<p>Slide 2 of 2</p>",
                      style: {
                        flexGrow: "unset",
                        fontSize: "20px",
                        flexBasis: "auto",
                        lineHeight: "24px",
                      },
                    },
                  },
                ],
              },
            ],
          },
          {
            id: "c41852f5-1bbc-4a37-a301-25cd709f4cb0",
            name: "Carousel Indicators",
            type: "carouselV3Indicators",
            props: {
              style: {
                top: "auto",
                left: "auto",
                right: "auto",
                bottom: "auto",
                zIndex: 2,
                display: "flex",
                position: "relative",
                alignSelf: "stretch",
                marginTop: "0px",
                alignItems: "center",
                marginLeft: "0px",
                paddingTop: "16px",
                paddingBottom: "16px",
                justifyContent: "center",
              },
            },
            children: [
              {
                id: "24bf9fe9-b5fa-444b-8fcc-c7882ba68637",
                name: "Container 10",
                type: "container",
                props: {
                  style: {
                    width: "10px",
                    cursor: "pointer",
                    height: "10px",
                    __width: "10px",
                    display: "flex",
                    __height: "10px",
                    flexGrow: "unset",
                    maxWidth: "100%",
                    alignSelf: "auto",
                    alignItems: "flex-start",
                    marginLeft: "10px",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    backgroundColor: "#0000004D",
                    borderTopLeftRadius: "20px",
                    borderTopRightRadius: "20px",
                    borderBottomLeftRadius: "20px",
                    borderBottomRightRadius: "20px",
                  },
                },
                children: [],
                variants: [
                  {
                    id: "1196784c-f2f3-4a4a-b167-221febbe6adf",
                    name: "default",
                    query: null,
                    componentOverrides: null,
                  },
                  {
                    id: "67637f96-1a39-4d09-ab9a-c798f1c899d0",
                    name: "Current item is active",
                    query: {
                      type: "expression",
                      operator: "or",
                      statements: [
                        {
                          id: "a5eefa18-3bc3-4890-a191-335f2c071f83",
                          field: "state.group.isCurrentItemActive",
                          value: null,
                          operator: null,
                        },
                      ],
                    },
                    componentOverrides: null,
                  },
                ],
                variantOverrides: {
                  "67637f96-1a39-4d09-ab9a-c798f1c899d0": {
                    componentOverrides: {
                      "24bf9fe9-b5fa-444b-8fcc-c7882ba68637": {
                        props: {
                          style: {
                            backgroundColor: "#000000FF",
                          },
                        },
                      },
                    },
                  },
                },
              },
            ],
          },
        ],
      },
      {
        id: "ed8e5afc-fdb7-42f3-82b7-84d32222c22c",
        name: "Next Button 1",
        type: "carouselV3Control",
        props: {
          style: {
            cursor: "pointer",
            display: "flex",
            flexGrow: "unset",
            alignSelf: "stretch",
            flexBasis: "auto",
            alignItems: "center",
            justifyContent: "center",
          },
          direction: "next",
        },
        children: [
          {
            id: "4397ebd2-dcf3-46f7-9bc3-cbb080c5ab63",
            type: "icon",
            props: {
              style: {
                width: "60px",
                height: "60px",
                __width: "60px",
                __height: "60px",
                flexGrow: "unset",
              },
              iconName: "chevronRight",
            },
            variantOverrides: {},
          },
        ],
        variants: [
          {
            id: "168e9eb6-e99d-443d-ae69-e3275e821e81",
            name: "default",
            query: null,
            componentOverrides: null,
          },
          {
            id: "58dc7e8d-98f7-462a-8ee3-978fcb854983",
            name: "Last Item",
            query: {
              type: "expression",
              operator: "or",
              statements: [
                {
                  id: "fa7db26c-7755-450b-b10f-b5f0f5c6a624",
                  field: "state.group.isLastItemActive",
                  value: null,
                  operator: null,
                },
              ],
            },
            componentOverrides: null,
          },
        ],
        variantOverrides: {
          "58dc7e8d-98f7-462a-8ee3-978fcb854983": {
            componentOverrides: {
              "4397ebd2-dcf3-46f7-9bc3-cbb080c5ab63": {
                props: {
                  style: {
                    opacity: "20%",
                  },
                },
              },
              "ed8e5afc-fdb7-42f3-82b7-84d32222c22c": {
                props: {
                  style: {
                    cursor: "default",
                  },
                },
              },
            },
          },
        },
      },
    ],
  },
};
